import { render, staticRenderFns } from "./VideoCountdownTimer.vue?vue&type=template&id=64a29198&scoped=true"
import script from "./VideoCountdownTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoCountdownTimer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VideoCountdownTimer.vue?vue&type=style&index=0&id=64a29198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a29198",
  null
  
)

export default component.exports